module.exports = __webpack_public_path__ + "media/assets/images/task_link-b62f9a5d5d840436d9ab001abfe74e95.png";